import React from "react"; // useEffect, // useState,

import { useTranslation } from "react-i18next";

import "./index.css";

import upArrow from "./img/previous_section.svg";
import downArrow from "./img/next_section.svg";

export default function DescriptionNavigation(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const forceAnimationUpdate = (e, direction) => {
    // Hanlde navigation interction (previous and next conditions)
    const keycode = e.keyCode ? e.keyCode : e.which;
    if (keycode === 13 || e === "click") {
      // Detected interaction (by click or enter key)

      if (direction === "up" && props.descriptionID !== "start") {
        if (props.descriptionID === "end") {
          // If at the end, got to last description
          props.forceAnimationTo(
            getPercentage(
              props.sceneData.Scrolly.descriptions[
                props.sceneData.Scrolly.descriptions.length - 1
              ].range.min
            )
          );
        } else if (props.descriptionID !== 1) {
          // If not the first, go to previous
          if (
            props.sceneData.Scrolly.descriptions[props.descriptionID - 1]
              .type === "widget"
          ) {
            // If navigating to previous from a widget, go to the end of the previous description
            props.forceAnimationTo(
              getPercentage(
                props.sceneData.Scrolly.descriptions[props.descriptionID - 2]
                  .range.max
              ),
              -1
            ); // second parameter is the number of frames to adjust for (considering matching start/end times)
          } else {
            // otherwise go to the start as usual
            if (
              getPercentage(
                props.sceneData.Scrolly.descriptions[props.descriptionID - 2]
                  .range.min
              ) === 0
            ) {
              // If going to a description start time of 0
              props.forceAnimationTo(0, 1); // second parameter is the number of frames to adjust for (considering matching start/end times)
            }
            props.forceAnimationTo(
              getPercentage(
                props.sceneData.Scrolly.descriptions[props.descriptionID - 2]
                  .range.min
              )
            );
          }
        } else {
          // Back to start
          window.scrollTo(0, 0);
        }
      }

      if (direction === "down" && props.descriptionID !== "end") {
        if (props.descriptionID === "start") {
          // If at start, go to first
          props.forceAnimationTo(
            getPercentage(props.sceneData.Scrolly.descriptions[0].range.min),
            1
          ); // second parameter is the number of frames to adjust for (considering matching start/end times)
        } else if (
          props.descriptionID === props.sceneData.Scrolly.descriptions.length
        ) {
          // If on the last, go to "end"
          window.scrollTo(0, document.body.scrollHeight);
        } else {
          // Go to next
          props.forceAnimationTo(
            getPercentage(
              props.sceneData.Scrolly.descriptions[props.descriptionID].range
                .min
            )
          );
        }
      }
    }
  };

  const getPercentage = (timeStamp) => {
    const seconds = toSeconds(timeStamp);
    const percentage = (seconds / props.totalTime) * 100;
    return percentage;
  };

  const toSeconds = (timeStamp) => {
    // "00:00.00" (minutes:seconds) to seconds for percentage calculations and comparisons
    const timeArr = timeStamp.split(":");
    const seconds = Number(timeArr[0]) * 60 + Number(timeArr[1]);
    return seconds;
  };

  const arrowBtn = (direction) => {
    // Render previous/next buttons
    return (
      <div
        aria-label={`${direction === "up" ? t("previous.string") : t("next.string")}`}
        tabIndex="0"
        role="button"
        style={{
          cursor:
            (props.descriptionID === "end" && direction === "down") ||
            (props.descriptionID === "start" && direction === "up")
              ? "default"
              : "pointer",
          pointerEvents:
            (props.descriptionID === "end" && direction === "down") ||
            (props.descriptionID === "start" && direction === "up")
              ? "none"
              : "auto",
        }}
        onKeyUp={(e) => {
          forceAnimationUpdate(e, direction);
          props.forceScroll("nav");
        }} // Detect Enter and pass button direction
        onClick={() => {
          forceAnimationUpdate("click", direction);
          props.forceScroll("nav");
        }} // Detect Click and pass button direction, also force animation scroll position to align
        onMouseOver={() => {
          document.getElementById(`${direction}-arrow`).style.filter =
            "invert(78%) sepia(70%) saturate(983%) hue-rotate(375deg) brightness(251%) contrast(96%)";
        }}
        onFocus={() => {
          document.getElementById(`${direction}-arrow`).style.filter =
            "invert(78%) sepia(70%) saturate(983%) hue-rotate(375deg) brightness(251%) contrast(96%)";
        }}
        onMouseOut={() => {
          document.getElementById(`${direction}-arrow`).style.filter = "none";
        }}
        onBlur={() => {
          document.getElementById(`${direction}-arrow`).style.filter = "none";
        }}
      >
        <img
          id={`${direction}-arrow`}
          className={`${direction === "up" ? "prevBtn" : "nextBtn"} ${props.descriptionID === "start" && direction === "up" ? "disabled" : ""} ${props.descriptionID === "end" && direction === "down" ? "disabled" : ""} arrowBtn 
                    `}
          src={direction === "up" ? upArrow : downArrow}
          alt=""
          aria-hidden="true"
        />
      </div>
    );
  };

  const progress = () => {
    // Render progress icon
    return (
      <div role="group" className="progress-container">
        <span className="sr-only">
          {`${t("contentProgress.string")} ${Math.floor(props.percentage)}%`}
        </span>
        <span className="progress-percentage" aria-hidden="true">
          {`${Math.floor(props.percentage)}%`}
        </span>
        <svg
          aria-hidden="true"
          className="progress-icon"
          width="36"
          height="42"
          viewBox="0 0 36 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 10.681L18 0.57735L35.5 10.681V30.8882L18 40.9919L0.5 30.8882V10.681Z"
            stroke="white"
          />
        </svg>
      </div>
    );
  };

  return (
    <div
      id="description-navigation"
      className="description-navigation"
      role="navigation"
      aria-label={t("sectionNavigation.string")}
      style={{
        display:
          props.sceneData.Scrolly.descriptions.length === 0 ? "none" : null,
        left: [props.bp !== "lg" && props.bp !== "xl" ? "12px" : null],
      }}
    >
      {arrowBtn("up")}
      {progress()}
      {arrowBtn("down")}
    </div>
  );
}
